import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bytesConverter'
})
export class BytesConverterPipe implements PipeTransform {
  transform(value: number | string, ...args: unknown[]): string {
    let numericValue: number;

    if (typeof value === 'string') {
      numericValue = parseFloat(value);
    } else {
      numericValue = value;
    }

    if (isNaN(numericValue) || numericValue < 0) {
      return '';
    }

    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    let unitIndex = 0;

    while (numericValue >= 1024 && unitIndex < units.length - 1) {
      numericValue /= 1024;
      unitIndex++;
    }

    return numericValue.toFixed(2) + ' ' + units[unitIndex];
  }
}
